import React, { FC } from 'react'
import { Toolbar, Link } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { ReactComponent as LogoImg } from '../../images/header/logo.svg'
import { routes } from '../../constants/routes'

const useStyles = makeStyles({
  toolbar: {
    maxWidth: 1184,
    width: '100%',
    height: 176,
    margin: '0 auto',
    padding: 0,
    borderBottom: '1px solid rgba(0,0,0,0.24)',
  },
  logo: {
    width: 166,
  },
})

export const HeaderOnBoarding: FC = () => {
  const classes = useStyles()

  return (
    <Toolbar className={classes.toolbar}>
      <Link href={routes.HOME}>
        <LogoImg className={classes.logo} />
      </Link>
    </Toolbar>
  )
}
